import ComparisonPage, { CompetitorData } from "@/components/marketing/ComparisonPage";

const competitor: CompetitorData = {
  name: "OpenTable",
  slug: "opentable",
  type: "Marketplace internationale premium",
  hasCommissionPerCover: true,
  hasPriceCeiling: false,
  complexity: "moyenne",
  targetAudience: "Restaurants haut de gamme",
  focus: "Acquisition clients",
  supportLanguage: "Anglais principalement",
  commissionPerCoverChf: "Commission par couvert appliquée (montant variable selon la source de la réservation)",
  countryOfOrigin: "États-Unis (groupe Booking Holdings)",
  websiteUrl: "https://www.opentable.ch",
  whenToChoose: [
    "Tu gères un restaurant haut de gamme avec une clientèle internationale",
    "Tu souhaites bénéficier du réseau mondial OpenTable",
    "Ton établissement est situé dans une grande ville ou zone touristique",
    "Tu es prêt à payer une commission par couvert en plus d'un abonnement pour la visibilité",
    "Tu cibles des clients business et touristes internationaux",
  ],
  pricingDescription:
    "OpenTable, leader mondial des réservations en ligne, combine un abonnement mensuel et une commission par couvert qui varie selon la source de la réservation (plateforme OpenTable vs réservations directes). Les tarifs exacts en Suisse ne sont pas publiés publiquement : contactez OpenTable directement pour une offre adaptée. Le support est principalement en anglais.",
  conclusionStrength:
    "les restaurants haut de gamme cherchant une visibilité internationale et une clientèle business ou touristes premium",
  // 27 imp / 0 click. Title cible le pain point support FR (OpenTable = anglais)
  // + commissions, qui sont les 2 freins principaux pour un resto suisse.
  seoTitle: "OpenTable vs Piktable : commissions vs forfait fixe Suisse",
  seoDescription: "OpenTable facture une commission par couvert et un support en anglais, Piktable est un forfait fixe avec support FR/CH. Comparatif des coûts réels et fonctionnalités pour restaurants suisses.",
};

const PiktableVsOpenTable = () => {
  return <ComparisonPage competitor={competitor} />;
};

export default PiktableVsOpenTable;
